var React = require('react');

function CaretDown (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.3841 14.5391C12.1842 14.7789 11.8158 14.7789 11.6159 14.5391L7.68341 9.82009C7.41202 9.49443 7.6436 9 8.06752 9L15.9325 9C16.3564 9 16.588 9.49443 16.3166 9.82009L12.3841 14.5391Z","fill":"currentColor"}));
}

CaretDown.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = CaretDown;

CaretDown.default = CaretDown;
